import { render, staticRenderFns } from "./balanceCard.vue?vue&type=template&id=2219ae04"
import script from "./balanceCard.vue?vue&type=script&lang=js"
export * from "./balanceCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports